import { useEffect as e, useState as t } from "react";
//#region src/hooks/useElementSize.ts
var n = (n) => {
	let [r, i] = t(), [a, o] = t();
	return e(() => {
		let e = new ResizeObserver((e) => {
			for (let t of e) t.contentRect && (i(t.contentRect.width), o(t.contentRect.height));
		});
		return n.current && e.observe(n.current), () => {
			e.disconnect();
		};
	}, [n]), [r, a];
};
//#endregion
export { n as default };

//# sourceMappingURL=useElementSize.js.map